import $ from "jquery";
import Splide from "@splidejs/splide";

$(function () {
	let cardsSlider = document.querySelectorAll(".aka-block-cards-image .splide");
	if (cardsSlider.length > 0) {
		for (let i = 0; i < cardsSlider.length; i++) {
			let cardsElement = cardsSlider[i];
			let cardsDefaultOptions = {
				autoWidth: true,
				type: "loop",
				rewind: false,
				start: 0,
				arrows: true,
				perPage: 1,
				pagination: false,
				mediaQuery: "min",
				breakpoints: {
					1280: {
						destroy: true,
					},
				},
			};

			let cards = new Splide(cardsElement, cardsDefaultOptions);
			cards.mount();
		}
	}
});